import script from "./WageBeforeAfterYearly.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageBeforeAfterYearly.vue?vue&type=script&setup=true&lang=ts"

import "./WageBeforeAfterYearly.vue?vue&type=style&index=0&id=0d6ceb9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6ceb9e"]])

export default __exports__